import { Paper, Tab, Tabs } from '@material-ui/core';
import * as React from 'react';
import { Link } from 'react-router-dom';

import GeneralSummary from './General/General';
import PlaceStats from './PlaceStats/PlaceStats';

class Dashboard extends React.Component<any, any> {
  public render() {
    let tabId;
    switch (window.location.hash) {
      case '#places':
        tabId = 1;
        break;
      case '#general':
      default:
        tabId = 0;
    }
    return (
      <Paper>
        <Tabs value={tabId} indicatorColor="primary" textColor="primary">
          <Tab label="General" component={Link} {...{ to: { hash: 'general' } } as any} />
          <Tab label="Places" component={Link} {...{ to: { hash: 'places' } } as any} />
        </Tabs>
        {tabId === 0 ? <GeneralSummary /> : null}
        {tabId === 1 ? <PlaceStats /> : null}
      </Paper>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Dashboard.tsx